import React, { useState } from 'react';
import Icon from 'components/AppIcon';

export default function AddCategoryModal({ onAdd, onClose }) {
  const [name, setName] = useState('');
  const [allocated, setAllocated] = useState('');
  const [weeklyLimit, setWeeklyLimit] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (!name?.trim()) { setError('Category name is required'); return; }
    if (!allocated || Number(allocated) <= 0) { setError('Please enter a valid amount'); return; }
    onAdd({ name: name?.trim(), allocated: Number(allocated), weeklyLimit: weeklyLimit ? Number(weeklyLimit) : null });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-[#0D1B2A] border border-[rgba(0,229,255,0.2)] rounded-2xl p-6 w-full max-w-md mx-4 shadow-2xl">
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-[#E2E8F0] font-semibold text-lg">Add Custom Category</h3>
          <button onClick={onClose} className="text-[#64748B] hover:text-[#E2E8F0] transition-colors">
            <Icon name="X" size={20} />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs text-[#64748B] block mb-1">Category Name</label>
            <input
              value={name}
              onChange={(e) => { setName(e?.target?.value); setError(''); }}
              placeholder="e.g. Gym, Subscriptions"
              className="w-full bg-[rgba(255,255,255,0.06)] border border-[rgba(0,229,255,0.15)] rounded-xl px-3 py-2.5 text-sm text-[#E2E8F0] focus:outline-none focus:border-[#00E5FF] placeholder-[#475569]"
            />
          </div>
          <div>
            <label className="text-xs text-[#64748B] block mb-1">Monthly Budget ($)</label>
            <input
              type="number"
              value={allocated}
              onChange={(e) => { setAllocated(e?.target?.value); setError(''); }}
              placeholder="0"
              min="0"
              className="w-full bg-[rgba(255,255,255,0.06)] border border-[rgba(0,229,255,0.15)] rounded-xl px-3 py-2.5 text-sm text-[#E2E8F0] focus:outline-none focus:border-[#00E5FF] placeholder-[#475569]"
            />
          </div>
          <div>
            <label className="text-xs text-[#64748B] block mb-1">Weekly Limit ($) <span className="text-[#475569]">(optional)</span></label>
            <input
              type="number"
              value={weeklyLimit}
              onChange={(e) => setWeeklyLimit(e?.target?.value)}
              placeholder="No limit"
              min="0"
              className="w-full bg-[rgba(255,255,255,0.06)] border border-[rgba(0,229,255,0.15)] rounded-xl px-3 py-2.5 text-sm text-[#E2E8F0] focus:outline-none focus:border-[#00E5FF] placeholder-[#475569]"
            />
          </div>
          {error && <p className="text-[#EF4444] text-xs">{error}</p>}
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 py-2.5 rounded-xl border border-[rgba(255,255,255,0.1)] text-[#94A3B8] text-sm hover:bg-[rgba(255,255,255,0.05)] transition-colors">
              Cancel
            </button>
            <button type="submit" className="flex-1 py-2.5 rounded-xl bg-gradient-to-r from-[#00E5FF] to-[#0891B2] text-[#0D1B2A] font-semibold text-sm hover:opacity-90 transition-opacity">
              Add Category
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
